/**
 * Stripe checkout client — talks to the stripe-checkout edge function.
 */

const API_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/stripe-checkout`;
const API_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

export interface CheckoutSessionResponse {
  url?: string;
  session_id?: string;
  test_mode?: boolean;
  success?: boolean;
  redirect_url?: string;
  program_id?: string;
  license_id?: string;
}

export async function createCheckoutSession(params: {
  user_id: string;
  program_id?: string;
  license_type?: "individual" | "agency" | "enterprise";
  price_plan_id: string;
  success_url?: string;
  cancel_url?: string;
}): Promise<CheckoutSessionResponse | null> {
  try {
    const res = await fetch(`${API_URL}/create-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${API_KEY}`,
      },
      body: JSON.stringify(params),
    });
    if (!res.ok) {
      console.warn("[stripe-checkout] create-session failed", res.status);
      return null;
    }
    return (await res.json()) as CheckoutSessionResponse;
  } catch (err) {
    console.warn("[stripe-checkout] create-session error", err);
    return null;
  }
}

export interface StripeProductInfo {
  id: string;
  name: string;
  description: string | null;
  metadata: Record<string, string>;
  prices: Array<{
    id: string;
    unit_amount: number;
    currency: string;
    metadata: Record<string, string>;
  }>;
}

export async function listStripeProducts(): Promise<StripeProductInfo[]> {
  try {
    const res = await fetch(`${API_URL}/products`, {
      headers: { Authorization: `Bearer ${API_KEY}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return data.products ?? [];
  } catch {
    return [];
  }
}
